import React, { FC } from 'react';
import key from 'weak-key';
import { BulletDescriptionPopupProps, IconDescriptionBullet } from '@/pages/CareersPage/CareersPage.types';
import CareersPopup from '@/pages/CareersPage/components/popups/CareersPopup/CareersPopup';
import { ReactComponent as CheckListIcon } from '@/assets/icons/check-list.svg';
import styles from './BulletDescriptionPopup.module.scss';

const BulletDescriptionPopup: FC<BulletDescriptionPopupProps> = ({
  title, backgroundImage, bullets, popupKey,
}) => {
  const renderIcon = (listItem: IconDescriptionBullet) => {
    const { text, iconUrl } = listItem;
    if (!text) {
      return null;
    }

    if (iconUrl) {
      return <img alt="" className={styles.icon} src={iconUrl} />;
    }

    return <CheckListIcon className={styles.icon} />;
  };

  return (
    <CareersPopup backgroundImage={backgroundImage} popupKey={popupKey} title={title}>
      <ul className={styles.list}>
        {bullets?.map((listItem) => (
          <li key={key(listItem)} className={styles.listItem}>
            {renderIcon(listItem)}
            <div className={styles.text}>
              <div className={styles.title}>
                {listItem.text}
              </div>
              {listItem.description && (
                <div className={styles.description}>
                  {listItem.description}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </CareersPopup>
  );
};
BulletDescriptionPopup.displayName = 'BulletDescriptionPopup';

export default BulletDescriptionPopup;
